import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { HOME_ROUTE } from '../../../constants/routes';

const PrivateRoute = ({ component: Component, authorized }) => {
  return (
    <Route
      render={(props) =>
        authorized === true ? (
          <Component {...props} />
        ) : (
          <Redirect to={HOME_ROUTE} />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any,
  authorized: PropTypes.bool,
};

export default PrivateRoute;
